import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { JobPointeTransferService } from '../job-pointe-transfer.service';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-employee-job',
  templateUrl: './add-employee-job.component.html',
  styleUrls: ['./add-employee-job.component.scss'],
})
export class AddEmployeeJobComponent implements OnInit {
  isAddToEmployeeModalOpen: boolean = false;
  modalSubscription: Subscription;
  rowSubscription: Subscription;
  jobBoardForm: FormGroup;
  selectedName: any = {};
  selectedRow: any = {};
  @ViewChild('addEmployeeJobModal') addEmployeeJobModal: ElementRef;
  @HostListener('document:click', ['$event'])
  clickedOut(event) {
    if (!this.addEmployeeJobModal?.nativeElement) return;
    if (event.target.className.includes('overlay')) this.handleClose();
  }

  constructor(private jobPointeTransferService: JobPointeTransferService) { }

  ngOnInit(): void {
    this.modalSubscription = this.jobPointeTransferService.addEmployeeModalIsOpenSource.subscribe(value => {
      if (!value) return

      this.isAddToEmployeeModalOpen = value.isOpen;
      this.selectedRow = value.cardData;
      this.selectedRow.cardType = value.cardType;
      this.selectedName =
        value.cardType == 'Job'
          ? `${value.cardData?.jobNumber} - ${value.cardData?.name}`
          : `${value.cardData?.owner.owner_name} - ${value.cardData?.facilityName}`;
    });
  }
  ngOnDestroy(): void {
    this.modalSubscription?.unsubscribe();
  }

  handleClose() {
    this.isAddToEmployeeModalOpen = false;
  }
}
